import { Vue } from 'vue-class-component';

import { KeyValueEntry } from '@/types/KeyValueEntry';
import { $t } from '@/modules/base-facade';

import './key-value-summary.scss';

const CN = 'key-value-summary';

class Props {
  list: KeyValueEntry[];
}

export default class KeyValueSummary extends Vue.with(Props) {
  render() {
    const { list } = this;
    return (
      <p class={CN}>
        <ul class={`${CN}__list`}>{list.map(this.renderEntry)}</ul>
      </p>
    );
  }

  private renderEntry({ key, value }: KeyValueEntry) {
    return (
      <li key={key} class={`${CN}__entry`}>
        <span aria-hidden={true} class={`${CN}__key`}>
          {key}
        </span>
        <span aria-label={key} class={`${CN}__value`}>
          {value ?? $t('common', 'n-a')}
        </span>
      </li>
    );
  }
}
